// src/components/contexts/EditorContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

// Create a context for the Quill editor
const EditorContext = createContext();

// Provider component
export function EditorProvider({ children }) {
  // State to hold the editor instance
  const [editorInstance, setEditorInstance] = useState(null);
  const [lastSelection, setLastSelection] = useState(null);

  // Add selection tracking
  useEffect(() => {
    if (editorInstance) {
      const handleSelectionChange = (range) => {
        if (range && range.length > 0) {
          setLastSelection(range);
        }
      };
      
      editorInstance.on('selection-change', handleSelectionChange);
      return () => editorInstance.off('selection-change', handleSelectionChange);
    }
  }, [editorInstance]);
  
  // Function to set the editor instance
  const setEditor = (editor) => {
    setEditorInstance(editor);
  };

  // Value to be provided by the context
  const value = {
    editor: editorInstance,
    setEditor,
    lastSelection
  };

  return (
    <EditorContext.Provider value={value}>
      {children}
    </EditorContext.Provider>
  );
}

// Custom hook to use the editor context
export function useEditor() {
  const context = useContext(EditorContext);
  if (!context) {
    throw new Error('useEditor must be used within an EditorProvider');
  }
  return context;
}